import { render, staticRenderFns } from "./JwJiaocaiPutinModal.vue?vue&type=template&id=da649890"
import script from "./JwJiaocaiPutinModal.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiPutinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports